const Icons = ({ icon, className }) => {
  const ICONS_LIST = {
    pointsSlider: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="6.85742"
          y="0.28418"
          width="9.69861"
          height="9.69861"
          transform="rotate(45 6.85742 0.28418)"
          fill="#02AEDF"
        />
      </svg>
    ),
    accordionArrow: (
      <svg className="xl:w-6 xl:h-6 w-5 h-5"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 19.2695L13.3828 18.3867L20.8828 10.8867L21.7695 10L20 8.23047L19.1172 9.11328L12.5 15.7305L5.88281 9.11719L5 8.23047L3.23047 10L4.11328 10.8828L11.6133 18.3828L12.5 19.2695Z"
          fill="black"
        />
      </svg>
    ),
    smileMessage: (
      <svg
        className="lg:size-28 size-24 xl:size-[164px]"
        width="164"
        height="164"
        viewBox="0 0 164 164"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          className="group-hover:fill-pacific-blue duration-300"
          clipRule="evenodd"
          d="M23.4286 117.143C23.4286 121.805 25.2794 126.274 28.577 129.566C31.8687 132.863 36.3377 134.714 41 134.714C49.651 134.714 61.1193 134.714 68.3236 134.714C70.4381 134.714 72.3885 135.851 73.4252 137.696L83.8918 156.239C86.4866 160.843 91.3597 163.69 96.6429 163.69C101.926 163.69 106.799 160.843 109.394 156.239L119.861 137.696C120.897 135.851 122.848 134.714 124.962 134.714C130.843 134.714 139.453 134.714 146.429 134.714C151.091 134.714 155.56 132.863 158.852 129.566C162.149 126.274 164 121.805 164 117.143C164 100.286 164 69.3661 164 52.5093C164 47.8528 162.149 43.3839 158.852 40.0863C155.56 36.7946 151.091 34.9378 146.429 34.9378H140.571V17.5714C140.571 12.9091 138.721 8.44013 135.423 5.14842C132.131 1.85084 127.662 0 123 0C98.4937 0 42.0777 0 17.5714 0C12.9091 0 8.44013 1.85084 5.14842 5.14842C1.85084 8.44013 0 12.9091 0 17.5714C0 37.8547 0 79.2881 0 99.5714C0 104.234 1.85084 108.703 5.14842 111.994C8.44013 115.292 12.9091 117.143 17.5714 117.143H23.4286ZM119.609 91.8634C113.57 96.1508 104.04 99.5714 93.7143 99.5714C83.3881 99.5714 73.8586 96.1508 67.8199 91.8634C65.1842 89.995 61.5234 90.6158 59.6491 93.2516C57.7807 95.8873 58.4015 99.548 61.0372 101.422C68.6691 106.834 80.6704 111.286 93.7143 111.286C106.758 111.286 118.759 106.834 126.391 101.422C129.027 99.548 129.648 95.8873 127.779 93.2516C125.905 90.6158 122.244 89.995 119.609 91.8634ZM128.857 34.9378V17.5714C128.857 16.0193 128.242 14.5257 127.141 13.4304C126.046 12.3293 124.552 11.7143 123 11.7143H17.5714C16.0193 11.7143 14.5257 12.3293 13.4304 13.4304C12.3293 14.5257 11.7143 16.0193 11.7143 17.5714V99.5714C11.7143 101.124 12.3293 102.617 13.4304 103.712C14.5257 104.814 16.0193 105.429 17.5714 105.429H23.4286V52.5093C23.4286 47.8528 25.2794 43.3839 28.577 40.0863C31.8687 36.7946 36.3377 34.9378 41 34.9378H128.857ZM76.1429 58.5714C82.6091 58.5714 87.8571 63.8194 87.8571 70.2857C87.8571 76.752 82.6091 82 76.1429 82C69.6766 82 64.4286 76.752 64.4286 70.2857C64.4286 63.8194 69.6766 58.5714 76.1429 58.5714ZM111.286 58.5714C117.752 58.5714 123 63.8194 123 70.2857C123 76.752 117.752 82 111.286 82C104.819 82 99.5714 76.752 99.5714 70.2857C99.5714 63.8194 104.819 58.5714 111.286 58.5714Z"
          fill="#EF767A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M119.18 91.8631C113.141 96.1505 103.612 99.5711 93.2857 99.5711C82.9596 99.5711 73.4301 96.1505 67.3913 91.8631C64.7556 89.9947 61.0948 90.6155 59.2205 93.2512C57.3521 95.8869 57.9729 99.5477 60.6087 101.422C68.2405 106.834 80.2419 111.285 93.2857 111.285C106.33 111.285 118.331 106.834 125.963 101.422C128.598 99.5477 129.219 95.8869 127.351 93.2512C125.477 90.6155 121.816 89.9947 119.18 91.8631ZM75.7143 58.5711C82.1806 58.5711 87.4286 63.8191 87.4286 70.2854C87.4286 76.7517 82.1806 81.9997 75.7143 81.9997C69.248 81.9997 64 76.7517 64 70.2854C64 63.8191 69.248 58.5711 75.7143 58.5711ZM110.857 58.5711C117.323 58.5711 122.571 63.8191 122.571 70.2854C122.571 76.7517 117.323 81.9997 110.857 81.9997C104.391 81.9997 99.1429 76.7517 99.1429 70.2854C99.1429 63.8191 104.391 58.5711 110.857 58.5711Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M147.904 35C147.415 34.9587 146.923 34.9378 146.429 34.9378H140.571V17.5714C140.571 12.9091 138.721 8.44013 135.423 5.14842C132.131 1.85084 127.662 0 123 0H17.5714C12.9091 0 8.44013 1.85084 5.14842 5.14842C1.85084 8.44013 0 12.9091 0 17.5714V99.5714C0 104.234 1.85084 108.703 5.14842 111.994C8.44013 115.292 12.9091 117.143 17.5714 117.143H23V105.429H17.5714C16.0193 105.429 14.5257 104.814 13.4304 103.712C12.3293 102.617 11.7143 101.124 11.7143 99.5714V17.5714C11.7143 16.0193 12.3293 14.5257 13.4304 13.4304C14.5257 12.3293 16.0193 11.7143 17.5714 11.7143H123C124.552 11.7143 126.046 12.3293 127.141 13.4304C128.242 14.5257 128.857 16.0193 128.857 17.5714V34.9378H41C40.5055 34.9378 40.0131 34.9587 39.5241 35H147.904Z"
          fill="#333333"
        />
      </svg>
    ),
    rightArrow: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.3094 16.0598L25.3734 15.0004L24.3141 13.941L17.5641 7.19102L16.5 6.12695L14.3812 8.25039L15.4406 9.30977L19.6312 13.5004H6H4.5V16.5004H6H19.6266L15.4359 20.691L14.3812 21.7504L16.5 23.8738L17.5594 22.8145L24.3094 16.0645V16.0598Z"
          fill="#02AFE0"
        />
      </svg>
    ),
    backToTop: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="stroke-white md:stroke-pacific-blue"
          d="M6 11L12 5L18 11M6 19L12 13L18 19"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </svg>
    ),
    sliderLeftArrow:(<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={className} d="M5.73047 12.5L6.61328 11.6172L14.1133 4.11719L15 3.23047L16.7695 5L15.8867 5.88281L9.26953 12.5L15.8828 19.1172L16.7695 20L15 21.7695L14.1172 20.8867L6.61719 13.3867L5.73047 12.5Z" fill="black"/>
      </svg>
      ),
    sliderRightArrow:(<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={className} d="M16.7695 12.5L15.8867 11.6172L8.38672 4.11719L7.5 3.23047L5.73047 5L6.61328 5.88281L13.2305 12.5L6.61719 19.1172L5.73047 20L7.5 21.7695L8.38281 20.8867L15.8828 13.3867L16.7695 12.5Z" fill="black"/>
      </svg>
      
      
      ),
  };

  return icon && ICONS_LIST[icon];
};

export default Icons;
